exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar {\n  background: #F1F5F7; }\n\n.main-navbar {\n  line-height: 2.9em;\n  cursor: default; }\n  .main-navbar .nav-item {\n    padding: 0 1.43em; }\n\n.nav-item.active, .nav-item.active:hover {\n  color: #fff;\n  background: #007BB9; }\n\n.nav-item:hover {\n  color: #fff;\n  background: #CDD0D2; }\n\n.header-wrapper {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center; }\n\n.header-wrapper ul {\n  display: inline; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/main-navbar/main-navbar.component.scss
// module id = ../../../../../src/app/core/components/main-navbar/main-navbar.component.scss
// module chunks = main